import React, { useEffect, useState } from "react";


import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Spin from 'antd/lib/spin';
import Pagination from 'antd/lib/pagination';
import { Table } from 'antd/lib/table';
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import AppService from './../../../../service/app_service'
import AuthenticationService from './../../../../service/authentication_service'
import UrlService from './../../../../service/url_service'
import TopBarComponent from './../../component/topbar_component'
import ModalComponent from './../../component/modal_component'
import SockJsClient from 'react-stomp';
import { PaystackButton } from "react-paystack"


//import "./../../pro_assets/css/protected.css";


var interval = null;
var downloadTimer = null;
const AirtimePage = () => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalTransactionCount, setTotalTransactionCount] = useState(0);

    const [showGiveawayModal, setShowGiveawayModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [amount, setAmount] = useState(0);
    const [description, setDescription] = useState('');
    
    const [giveaways, setGiveaways] = useState([]);
    const [clientRef, setClientRef] = useState(null);
    const [orderRef, setOrderRef] = useState((new Date()).getTime().toString());

    const [channel, setChannel] = useState(null);
    const [email, setEmail] = useState(AuthenticationService.getEmail());
    const [name, setName] = useState(AuthenticationService.getName());
    const [phone, setPhone] = useState(AuthenticationService.getMobileNumber());
    const [publicKey, setPublicKey] = useState('pk_test_2372fc72b7cb8c49bab910c839370a2bbbc855b4');
    const [paystackAmount, setPaystackAmount] = useState(9000);
    

    const [totalAmount, setTotalAmount] = useState(null);
    

    useEffect(() => {
        setChannel(channelGenerator());
        getTransactions(pageNumber);
        //eslint-disable-next-line
        
    }, []);

    const getTransactions = async (pageNumber) => {
        setLoading(true);
        AppService.getOrdersByCategory(pageSize, pageNumber, 'AIRTIME_DISBURSEMENT').then(rec => {
            setLoading(false)
            if (rec.error) {
                // AuthenticationService.clearLocalstorage();
                // this.props.history.push('/');
            } else {
                setLoading(false);
                setTransactions(rec.list)
                if(rec &&  rec.list){
                    //setTotalTransactionCount(rec.list.length);
                }
            }
        })
    }

    const changePage= (val) =>{
        setPageNumber(val)
        getTransactions(val);
    }

    const paymentConfirmationCron = (ref) => {
        // navigator.serviceWorker.ready.then(registration => {
        //     interval = setInterval(() => {
        //         paymentConfirmation(false, ref);
        //         //registration.showNotification(title, options)
        //     }, 10000)
        // })
        interval = setInterval(() => {
            paymentConfirmation(false, ref);
        }, 10000)
    }

    const paymentConfirmation = (alerter, ref) => {
        setLoading(alerter);
        console.log("ref:",ref)
        let data = {};
        data.order = {};
        data.order.orderRef = ref;
        AppService.paymentConfirmation(data).then(rec => {

            setLoading(false);
            if (!rec.code) {
                if (rec.action === 'SUCCESS') {
                    message.success(rec.message);
                    //call back for order to be checked out
                    clearInterval(interval);
                    clearInterval(downloadTimer);
                    var element = document.getElementById("countdown");
                    if (element)
                        element.innerHTML = rec.message;

                    setShowModal(false);
                    setChannel(channelGenerator());
                    getTransactions(pageNumber);
                }
            } else {
                if(rec.description == 'Transaction has expired'){
                    clearInterval(interval);
                    clearInterval(downloadTimer);
                    var element = document.getElementById("countdown");
                    if (element)
                        element.innerHTML = rec.message;

                    message.error(rec.description);
                    setShowModal(false);
                }
                else if (alerter){
                    message.error(rec.description)
                }
                    
            }

        })

    }

    const startCounter = (timeleft) => {
        downloadTimer = setInterval(function () {
            if (timeleft <= 4) {
                clearInterval(downloadTimer);
                if (document.getElementById("countdown") != null)
                    document.getElementById("countdown").innerHTML = "Time is up";
            } else {
                var minutes = Math.floor(timeleft / 60);
                var seconds = timeleft - (minutes * 60);
                var left = minutes + ":" + seconds;
                var element = document.getElementById("countdown");
                if (element) {
                    element.innerHTML = left;
                }
                    

            }
            timeleft -= 1;
        }, 1000);
    }
    

    const createOrder = () => {
        let data = {};
        data.description = description;
        data.totalAmount = totalAmount;
        AppService.createAirtimeOrder(data).then(rec => {

            setLoading(false);
            if (!rec.code) {
                message.success("Order created successfully.");
                setShowGiveawayModal(false);
                getTransactions(pageNumber);

            } else {
                message.error(rec.description);
            }

        })
    };

    const config = {
        reference: orderRef,
        email: email,
        amount: paystackAmount,
        publicKey: publicKey,
        metadata: {
            name: name,
            phone: phone,
        }
    };

    const componentProps = {
        ...config,
        publicKey,
        text: "Pay Now",
        onSuccess: () => {
            verifyPaystackPayment();
        },
        onClose: () => alert("Wait! Don't leave :("),
    }

    const setAmountState = (amount) => {
        setAmount(amount);
        setPaystackAmount(100 * (amount + (200 + (1.5 * amount/100))));
    }

    const verifyPaystackPayment = () => {
        let arr = giveaways.map(item => (item.amount+'_'+ item.quantity+'_'+ item.gameType+'_'+ item.duration+'_'+ item.rewardType+'_'+ item.rewardPosition));
        
        let codedMessage = "giveaway:"+ arr.toString();
        let data = {};
        data.xo = AuthenticationService.getToken();
        data.emailAddress = AuthenticationService.getEmail();
        data.channel = channel;
        data.amount = amount;
        data.reference = orderRef;
        data.codedMessage = codedMessage;
        data.message = "GIVEAWAY";
        console.log("data:", data);
        AppService.paystackPaymentConfirmation(data).then(rec => {

            setLoading(false);
            if (!rec.code) {
                message.success("Payment successful, Giveaway generation in progress.");
                setOrderRef((new Date()).getTime().toString());
                setShowGiveawayModal(false);
                getTransactions(pageNumber);

            } else {
                message.error(rec.description);
            }

        })
    };

    // const payWithPaystack =() => {
    //     var handler = PaystackPop.setup({
    //         key: 'pk_test_2372fc72b7cb8c49bab910c839370a2bbbc855b4', // Replace with your public key
    //         email: "ionyekanna@gmail.com",
    //         amount: 32500 * 100, // the amount value is multiplied by 100 to convert to the lowest currency unit
    //         currency: 'NGN', // Use GHS for Ghana Cedis or USD for US Dollars
    //         ref: (Math.random() + 1).toString(36).substring(7), // Replace with a reference you generated
    //         callback: function(response) {
    //         //this happens after the payment is completed successfully
    //         var reference = response.reference;
    //         alert('Payment complete! Reference: ' + reference);
    //         // Make an AJAX call to your server with the reference to verify the transaction
    //         },
    //         onClose: function() {
    //         alert('Transaction was not completed, window closed.');
    //         },
    //     });
    //     handler.openIframe();
    // }

    const handleChange = (e) => {
        if(e.target.name === 'description'){
            setDescription(e.target.value);
        }else if(e.target.name === 'totalAmount'){
            setTotalAmount(e.target.value);
        }
        

    }


    const channelGenerator = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }

    const formatAmount = (amount) => {
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

    const columns = [
        {
          title: 'Full Name',
          width: 100,
          dataIndex: 'name',
          key: 'name',
          fixed: 'left',
        },
        {
          title: 'Age',
          width: 100,
          dataIndex: 'age',
          key: 'age',
          fixed: 'left',
        },
        {
          title: 'Column 1',
          dataIndex: 'address',
          key: '1',
          width: 150,
        },
        {
          title: 'Column 2',
          dataIndex: 'address',
          key: '2',
          width: 150,
        },
        {
          title: 'Column 3',
          dataIndex: 'address',
          key: '3',
          width: 150,
        },
        {
          title: 'Column 4',
          dataIndex: 'address',
          key: '4',
          width: 150,
        },
        {
          title: 'Amount',
          dataIndex: 'amount',
          key: 'amount',
          render: (item) => <span className="lead token-amount">&#8358; {parseFloat(item.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>,
        },
        {
          title: 'Status',
          key: 'status',
          render: (item) => <span className="lead amount-pay">{item.givenToPhoneNumber ? 'REDEEMED' : 'PENDING'}</span>,
        },
        {
          title: 'Copy',
          key: 'copy',
          render: (item) => <button onClick={() => { navigator.clipboard.writeText("https://dogiveaway.com/?giveawayId="+item.uid); message.info(' Copied to Clipboard') }} className="copy-triggers copy-clipboard" data-clipboard-text={"https://dogiveaway.com/?giveawayId="+item.uid}><em className="ti ti-files" /></button>
        },
        { title: 'Column 8', dataIndex: 'address', key: '8' },
        {
          title: 'Action',
          key: 'operation',
          fixed: 'right',
          width: 100,
          render: (item) => <a target="_blank" href={"https://dogiveaway.com/?giveawayId="+item.uid}>Open Giveaway</a>,
        },
      ];


    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3',minHeight: '700px' }} >
            <TopBarComponent />
            <div className="page-content">
                <div className="container">
                    <div className="card content-area">
                        <div className="card-innr">
                            <div className="card-head" style={{width: '100%'}}>
                                <h4 className="card-title">My Airtime Disbursement  <em className="text-primary ti ti-reload" style={{paddingLeft: '15px'}}  onClick={() => getTransactions(pageNumber)} /></h4>
                                <div   style={{float: 'right', margin: '10px 0px', width: '100%'}}>
                                    <a className="btn btn-sm btn-outline btn-light" onClick={() => setShowGiveawayModal(true)} style={{float: 'right'}}><em className="text-primary ti ti-files" /><span>Create New Disbursement</span></a>
                                </div>
                            </div>

                            <div className="content-area card"  style={{width: '100%'}}>
                                <div className="card-innr">
                                    <div className="card-head">
                                        <h4 className="card-title">Airtime Disbursement</h4>
                                    </div>
                                    <p>
                                    Disburse airtime in bulk to your beneficiaries.
                                    </p>
                                    <Link to={"/giveaway/detail/ALL"}><span className={"tnx-type-md badge badge-outline badge-success badge-md"} >View ALL</span><span className="tnx-type-sm badge badge-sq badge-outline badge-success badge-md">P</span></Link>
                                </div>
                            </div>

                            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer" style={{paddingTop: '10px', marginTop: '40px'}}>
                                <div className="table-wrap">
                                
                                <Spin spinning={loading}>
                                <table className="data-table dt-init user-tnx dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                        <thead>
                                            <tr className="data-item data-head" role="row">
                                                <th className="data-col dt-tnxno sorting_disabled" rowSpan={1} colSpan={1}>Order</th>
                                                <th className="data-col dt-token sorting_disabled" rowSpan={1} colSpan={1}>Amount</th>
                                                <th className="data-col dt-usd-amount sorting_disabled" rowSpan={1} colSpan={1}>Created By</th>
                                                <th className="data-col dt-type sorting_disabled" rowSpan={1} colSpan={1}>
                                                    <div className="dt-type-text">View</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { transactions && transactions.length > 0 && transactions.map((item, i) => {
                                                return<tr className="data-item odd" role="row" key={i}>
                                                <td className="data-col dt-tnxno">
                                                    <div className="d-flex align-items-center">
                                                        <div className={"data-state "+(item.status === "COMPLETED" ? 'data-state-approved' : (item.status === "EXPIRED" ? 'data-state-canceled' : 'data-state-progress'))}><span className="d-none">{item.status}</span></div>
                                                        <div className="fake-class"><span className="lead tnx-id">{item.description}</span><span className="sub sub-date">{item.createdAt}</span></div>
                                                    </div>
                                                </td>
                                                <td className="data-col dt-token"><span className="lead token-amount">&#8358; {parseFloat(item.totalAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span><span className="sub sub-symbol">{item.status}</span></td>
                                                
                                                <td className="data-col dt-usd-amount"><span className="lead amount-pay">{item.createdBy}</span></td>
                                                <td className="tnx-type"><Link to={"/airtime/disbursement/detail/"+item.orderRef}><span className={"" +(item.status === "COMPLETED" ? 'tnx-type-md badge badge-outline badge-success badge-md' : (item.status === "EXPIRED" ? 'tnx-type-md badge badge-outline badge-danger badge-md' : 'tnx-type-md badge badge-outline badge-warning badge-md'))}  >View</span><span className="tnx-type-sm badge badge-sq badge-outline badge-success badge-md">View</span></Link> </td>
                                                
                                            </tr> }) }

                                            {transactions && transactions.length > 0 && <tr>
                                                <Pagination onChange={changePage} pageSize={pageSize} defaultCurrent={pageNumber} current={pageNumber} total={totalTransactionCount} />
                                            </tr>}
                                        </tbody>
                                    </table>
                                </Spin>
                                </div>
                            </div>
                        </div>
                        {/* .card-innr */}
                    </div>
                    {/* .card */}
                </div>
                {/* .container */}
            </div>

            

                {showGiveawayModal && <ModalComponent show={setShowGiveawayModal} closeModal={() => setShowGiveawayModal(false)} title="Create" >
                    <div >
                        <Spin spinning={loading}>
                            <div className="row scroll-modal" >
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Title</label>
                                        <input type="text" name="description" value={description} className="input-bordered" placeholder="Description" onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Estimated Amount</label>
                                        <input type="number" name="totalAmount" value={totalAmount} className="input-bordered" placeholder="Estimated Total Amount" onChange={handleChange} />
                                    </div>
                                </div>
                    

                                <hr />
                                <br />
                                <br />
                                <br />
                                

                                {description && totalAmount > 0 && <div className="col-md-12">
                                    {<Popconfirm
                                        title="Are you sure to submit this?"
                                        onConfirm={createOrder}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" disabled={loading} name="submit" className="btn btn-success btn-block">Submit</button>
                                    </Popconfirm>}
                                </div>}
                            

                            </div>
                        </Spin>




                    </div>
                </ModalComponent>}

                



        </div>
    );

}

export default withRouter(AirtimePage);
